import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getEditorialTeamProofsOptions,
  useDeleteEditorialTeamProof,
  useUploadOrUpdateEditorialTeamProof,
} from './model/EditorialTeamProofModel';

interface EditorialTeamProofActionProps {
  editorialTeamId: number;
  authors: Author[];
  variant?: 'compact';
}

export function EditorialTeamProofAction({ editorialTeamId, authors }: EditorialTeamProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getEditorialTeamProofsOptions(editorialTeamId));
  const uploadOrUpdateMutation = useUploadOrUpdateEditorialTeamProof(editorialTeamId);
  const deleteMutation = useDeleteEditorialTeamProof(editorialTeamId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="editorial-team"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
